module.exports = __webpack_public_path__ + "static/media/channel-check.6f0b4c69.svg";